/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LevelGateType } from './LevelGateType';
import {
    LevelGateTypeFromJSON,
    LevelGateTypeFromJSONTyped,
    LevelGateTypeToJSON,
    LevelGateTypeToJSONTyped,
} from './LevelGateType';

/**
 * 
 * @export
 * @interface LevelGate
 */
export interface LevelGate {
    /**
     * 
     * @type {LevelGateType}
     * @memberof LevelGate
     */
    type: LevelGateType;
    /**
     * 
     * @type {string}
     * @memberof LevelGate
     */
    nftGroupingId?: string;
    /**
     * 
     * @type {string}
     * @memberof LevelGate
     */
    subscriptionTierId?: string;
    /**
     * Minimum subscription tier level required to pass this gate. Used when type is SUBSCRIPTION_TIER.
     * @type {number}
     * @memberof LevelGate
     */
    minimumTierLevel?: number;
}



/**
 * Check if a given object implements the LevelGate interface.
 */
export function instanceOfLevelGate(value: object): value is LevelGate {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function LevelGateFromJSON(json: any): LevelGate {
    return LevelGateFromJSONTyped(json, false);
}

export function LevelGateFromJSONTyped(json: any, ignoreDiscriminator: boolean): LevelGate {
    if (json == null) {
        return json;
    }
    return {
        
        'type': LevelGateTypeFromJSON(json['type']),
        'nftGroupingId': json['nftGroupingId'] == null ? undefined : json['nftGroupingId'],
        'subscriptionTierId': json['subscriptionTierId'] == null ? undefined : json['subscriptionTierId'],
        'minimumTierLevel': json['minimumTierLevel'] == null ? undefined : json['minimumTierLevel'],
    };
}

export function LevelGateToJSON(json: any): LevelGate {
    return LevelGateToJSONTyped(json, false);
}

export function LevelGateToJSONTyped(value?: LevelGate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': LevelGateTypeToJSON(value['type']),
        'nftGroupingId': value['nftGroupingId'],
        'subscriptionTierId': value['subscriptionTierId'],
        'minimumTierLevel': value['minimumTierLevel'],
    };
}

